import { connect } from 'react-redux';
import { SelectContentComponent } from './select-content.component';

const mapStateToProps = state => {
  return {
    lang: state.lang.CONTENT_SELECTOR,
    knowledge: state.knowledge,
    admission: state.admission,
    lab: state.lab,
  };
};

export const SelectContent = connect(mapStateToProps)(SelectContentComponent);
